import { init } from '@rematch/core';
import * as models from './models';

export default init({
    models
});
